@let assets = assets$ | async;

@if (assets) {
    <loren-map [assets]="assets"/>
}
